var exports = {
  "b7": "AvatarCostume.module__costume___b3pQOG",
  "Nl": "AvatarCostume.module__topper___b3pQOG",
  "hN": "AvatarCostume.module__ring___b3pQOG",
  "um": "AvatarCostume.module__faceOverlay___b3pQOG",
  "Hg": "AvatarCostume.module__costumeOverhang___b3pQOG",
  "Ub": "AvatarCostume.module__costumeBase___b3pQOG",
  "j8": "AvatarCostume.module__silhouette___b3pQOG",
  "Xu": "AvatarCostume.module__fullColor___b3pQOG",
  "sW": "AvatarCostume.module__accented___b3pQOG",
  "aM": "AvatarCostume.module__noHalo___b3pQOG",
  "y2": "AvatarCostume.module__partHaloActive___b3pQOG",
};

module.exports = exports;
